import Brain from '../../classes/brain';
import Utils from '../../classes/utils';
import LFO from '../../classes/lfo';
import * as Matter from 'matter-js';

export default class BrainPulsatingShape extends Brain {

	constructor(args) {
		super(args);

		this.lfo = new LFO(Utils.randomFloatSeeded(0.1,0.3));
	}

	init(entity) {
		super.init(entity);

		let g = entity.sprite.g;

		g.onpointerdown = (e) => {
			Matter.Body.setVelocity(this.entity.sprite.body, {x:Utils.randomFloatSeeded(-5, 5), y:Utils.randomFloatSeeded(-20, -10)});
			Matter.Body.setAngularVelocity(this.entity.sprite.body, Utils.randomFloatSeeded(-0.3, 0.3));
			this.entity.sprite.color = this.entity.sprite.baseColor;
			this.entity.sprite.slop = 0;
			this.system.audio.playSample('ride');
		};

		g.onpointerover = (e) => {
			this.entity.sprite.color = 0xffffff;
			this.entity.sprite.slop = 4;
		};

		g.onpointerout = (e) => {
			this.entity.sprite.color = this.entity.sprite.baseColor;
			this.entity.sprite.slop = 0;
		};
	}

	update(delta) {
		super.update(delta);

		this.lfo.update(delta);

		// // shrink / grow the physics body
		let s = 1+(this.lfo.value*0.00025*delta);
		Matter.Body.scale(this.entity.sprite.body, s, s);

		// // vectors wobble when growing
		this.entity.sprite.wobble = Math.max(0, -17.5 + this.lfo.value*20) * 2;
	}

}